import { css } from '@emotion/css';

import {
  AlignItems,
  BorderRadius,
  Color,
  Display,
  Font,
  FontWeight,
  JustifyContent,
  ScreenBreakpoint,
  Spacing,
} from '../../../styles';

export const mainContainer = css`
  background-color: ${Color.Gray2};

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    background: ${Color.Gray1};
  }
`;

export const pageName = css`
  ${Spacing.mt64}
  ${Spacing.ml8}

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${Spacing.mt32}
    ${Spacing.ml0}
    ${Spacing.px16}
  }
`;

export const menuItem = ({ isActive }: { isActive: boolean }) => css`
  ${Display.flex}
  ${AlignItems.center}
  ${Spacing.pl24}
  ${Spacing.py16}
  ${Spacing.mlAuto}
  ${Spacing.mr24}
  ${Spacing.mb16}
  ${BorderRadius.xs}
  ${Font.h6}
  ${isActive ? FontWeight.semibold : FontWeight.normal}
  cursor: pointer;
  color: ${Color.Brand6} !important;
  background-color: ${isActive ? Color.Brand1 : 'inherit'};
`;

export const menuItemIconContainer = css`
  ${Spacing.mlAuto}
  ${Spacing.mr24}
  ${Display.flex}
  ${AlignItems.center}
`;

export const menuItemIcon = ({ isComplete }: { isComplete: boolean }) => css`
  ${Font.h5}
  ${FontWeight.semibold}
  color: ${isComplete ? Color.Green6 : Color.Brand6};

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${Font.lg}
    ${FontWeight.bold}
    ${Spacing.px4}
  }
`;

export const tabsContainer = css`
  ${Spacing.ml16}

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${Spacing.ml0}
    ${Spacing.px16}
  }
`;

export const tabLabelContainer = css`
  ${Display.flex}
  ${AlignItems.center}
  ${JustifyContent.center}
  ${Font.h6}
`;
